import React, { useState, useEffect } from 'react';
import '../../styles/Admin.css';

interface Role {
  __enumName__: string;
  _code: string;
  _name: string;
}

interface User {
  id?: string;
  username: string;
  password?: string;
  role: Role;
  school: string;
}

interface UserFormProps {
  user?: User;
  onSubmit: (userData: any) => Promise<void>;
  onCancel: () => void;
}

const UserForm: React.FC<UserFormProps> = ({ user, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    role: 'STUDENT',
    school: ''
  });

  useEffect(() => {
    if (user) {
      setFormData({
        username: user.username,
        password: '',
        role: user.role._code,
        school: user.school || ''
      });
    }
  }, [user]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // 비밀번호가 비어있고 수정 모드일 경우 비밀번호 필드를 제외하고 전송
    if (user && !formData.password) {
      const { password, ...dataWithoutPassword } = formData;
      await onSubmit(dataWithoutPassword);
    } else {
      await onSubmit(formData);
    }
  };

  return (
    <div className="user-form">
      <div className="form-header">
        <h3 className="admin-card-title">
          {user ? '사용자 정보 수정' : '새 사용자 추가'}
        </h3>
        <p className="admin-subtitle">
          {user ? '사용자의 정보를 수정합니다.' : '새로운 사용자를 시스템에 추가합니다.'}
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-grid">
          <div className="form-group">
            <label className="form-label">사용자명</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              className="form-input"
              placeholder="사용자 이름을 입력하세요"
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              비밀번호
              {user && <span className="form-label-optional"> (변경 시에만 입력)</span>}
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required={!user}
              className="form-input"
              placeholder={user ? "변경할 비밀번호를 입력하세요" : "비밀번호를 입력하세요"}
            />
          </div>

          <div className="form-group">
            <label className="form-label">역할</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              required
              className="form-select"
            >
              <option value="STUDENT">학생</option>
              <option value="PROFESSOR">교수</option>
              <option value="ADMIN">관리자</option>
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">학교</label>
            <input
              type="text"
              name="school"
              value={formData.school}
              onChange={handleChange}
              className="form-input"
              placeholder="학교 이름을 입력하세요"
            />
          </div>
        </div>

        <div className="form-actions">
          <button
            type="button"
            onClick={onCancel}
            className="btn btn-secondary"
          >
            취소
          </button>
          <button
            type="submit"
            className="btn btn-primary"
          >
            {user ? '수정' : '생성'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default UserForm;
